/**
 * Created by tomere on 23/04/2018.
 */
import CreateBundleDAO from '../DAO/CreateBundleDAO';

export default class BundleCreationDryRunService {

	constructor($rootScope, JFrogModal, JFrogEventBus, createBundleDAO) {
		this.$rootScope = $rootScope;
		this.modal = JFrogModal;
		this.jFrogEventBus = JFrogEventBus;
        this.EVENTS = JFrogEventBus.getEventsDefinition();
        this.createBundleResource = createBundleDAO.Resource;
	}

	/**
	 *  launch the distribution modal
	 */
	showDryRunModal(bundleCreationJson,type) {
		this.modalScope = this.$rootScope.$new();
		this.modalScope.header = 'Bundle Creation Dry Run';
		this.modalScope.dryRunData = bundleCreationJson;
		this.modalScope.hasErrors = type === 'error';

		this.modalScope.closeModal = () => {
			return this.modalInstance.close();
		};

		this.modalInstance = this.modal
		                         .launchModalWithTemplateMarkup(require('./bundle.creation.dry.run.service.modal.html'),
			                         this.modalScope, 'lg');

		this.jFrogEventBus.dispatch(this.EVENTS.HIDE_SPINNER);
	};

	dryRun(createReleaseBundleModel) {
		let bundleCreationJson = createReleaseBundleModel.build();
		bundleCreationJson.dry_run = true;
		this.jFrogEventBus.dispatch(this.EVENTS.SHOW_SPINNER);
		this.createBundleResource.dryRun(bundleCreationJson).$promise.then(response => {
			this.jFrogEventBus.dispatch(this.EVENTS.HIDE_SPINNER);
			if(response) {
				this.showDryRunModal(JSON.stringify(response, null, "\t"));
			}
		}, error => {
			let msg = error.data.errors[0].message || error.data.errors[0].defaultMessage || error.data.errors[0] || error.data || error;
			this.showDryRunModal(msg, 'error');
		})
	}

}

BundleCreationDryRunService.META = {
	name: 'BundleCreationDryRunService'
};

BundleCreationDryRunService.$inject = ['$rootScope',
                                     'JFrogModal',
                                     'JFrogEventBus',
                                       CreateBundleDAO.META.name
];



// WEBPACK FOOTER //
// ./modules/distribution/modules/distribution/components/bundle/create/bundleCreationDryDunService/bundle.creation.dry.run.service.js